import { AddCartItemOptions } from '../content/changesets/add';
import addCartItems from './addCartItems';

const addCartItem = (options: AddCartItemOptions) => addCartItems([options]);

export default addCartItem;
